import React from 'react';
import ResultsLogoSwiper from '../ResultsLogoSwiper';

const HomePartners = () => {
  return (
    <div className="partners">
      <div className="container">
        <div className="slider-section">
          <div className="left-section">
            <span>Our clients</span>
          </div>
          <div className="slider-part">
            <ResultsLogoSwiper />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePartners;
